import SendMessageForm from './SendMessageForm';

export const Empty = {
  component: SendMessageForm,
  props: {
    formId: 'SendMessageForm.Empty.Form',
    messagePlaceholder: 'Send message to Juho…',
    onChange: values => {
      console.log('values changed to:', values);
    },
    onSubmit: values => {
      console.log('submit values:', values);
    },
    onFocus: () => {
      console.log('focus on message form');
    },
    onBlur: () => {
      console.log('blur on message form');
    },
  },
  group: 'forms',
};

export const InProgress = {
  component: SendMessageForm,
  props: {
    formId: 'SendMessageForm.InProgress.Form',
    messagePlaceholder: 'Send message to Juho…',
    inProgress: true,
    onSubmit: values => {
      console.log('submit values:', values);
    },
  },
  group: 'forms',
};

export const Error = {
  component: SendMessageForm,
  props: {
    formId: 'SendMessageForm.Error.Form',
    messagePlaceholder: 'Send message to Juho…',
    sendMessageError: { type: 'error', name: 'ExampleError' },
    onSubmit: values => {
      console.log('submit values:', values);
    },
  },
  group: 'forms',
};

// Chat composer with message attachments staged (see MessageAttachmentsPicker).
export const WithAttachments = {
  component: SendMessageForm,
  props: {
    formId: 'SendMessageForm.WithAttachments.Form',
    messagePlaceholder: 'Send message to Juho…',
    stagedAttachments: [
      {
        tempId: 'a',
        fileId: 'file-a',
        name: 'brief.pdf',
        size: 120000,
        progress: 100,
        state: 'available',
        error: null,
      },
      {
        tempId: 'b',
        fileId: null,
        name: 'reference-images.zip',
        size: 5000000,
        progress: 42,
        state: 'uploading',
        error: null,
      },
    ],
    onUploadAttachment: file => console.log('upload attachment:', file.name),
    onRemoveAttachment: tempId => console.log('remove attachment:', tempId),
    onSubmit: values => {
      console.log('submit values:', values);
    },
  },
  group: 'forms',
};
